import { Injectable } from '@angular/core';
import { HistoricoEtiquetadoFilters } from '../models/historico-etiquetado-filters.component';
import { HistoricoConsumosFilters } from '../models/historico-consumos-filters.component';
import { HistoricoCultivosFilters } from '../models/historico-cultivos-filters.component';
import { HistoricoDesignacionesFilters } from '../models/historico-designaciones-filters.component';
import { HistoricoReetiquetadoFilters } from '../models/historico-reetiquetado-filters.component';
import { HistoricoTotalesFilters } from '../models/historico-totales-filters.component';

@Injectable()
export class HistoricoContextService {
    public historicoCultivosFilters: HistoricoCultivosFilters;
    public historicoDesignacionesFilters: HistoricoDesignacionesFilters;
    public historicoConsumosFilters: HistoricoConsumosFilters;
    public historicoEtiquetadoFilters: HistoricoEtiquetadoFilters;
    public historicoReetiquetadoFilters: HistoricoReetiquetadoFilters;
    public historicoTotalesFilters: HistoricoTotalesFilters;
}
